import "intersection-observer";
import scrollama from "scrollama";

const SectionAnimate = () => {
    const sections = document.querySelectorAll("[data-color]");
    const body = document.querySelector("body");

    function clearSectionActive() {
        sections.forEach(section => {
            section.classList.remove("is-active");
        });
    }

    function sectionDown(el) {
        const sectionColor = el.dataset.color;
        // console.log(sectionColor);

        clearSectionActive();

        body.className = "";

        el.classList.add("is-active");

        body.classList.add(sectionColor);

        // console.log(el.id + " visible");
    }

    function sectionUp(el) {
        const sectionColor = el.dataset.color;
        clearSectionActive();
        body.className = "";
        el.classList.add("is-active");
        body.classList.add(sectionColor);
        // console.log(el.id + " hidden");
    }

    if (sections) {
        // instantiate the scrollama
        const scroller = scrollama();

        // setup the instance, pass callback functions
        scroller
            .setup({
                step: "[data-color]"
            })
            .onStepEnter(response => {
                // { element, index, direction }
                // console.log(response);

                sectionDown(response.element);
            });
        // .onStepExit(response => {
        //     // { element, index, direction }
        //     console.log(response);
        // });

        // setup resize event
        window.addEventListener("resize", scroller.resize);
    }
};

export default SectionAnimate;
